import React, { ReactNode, FC } from 'react';
import { ThemeProvider } from 'styled-components';
import Header from './../../sections/Header';
import Footer from './../../sections/Footer';
import { IConfig } from '../../types/config';
import CookiesConsent from './../../sections/CookiesConsent/index';

import GlobalStyle, { globalVariables } from './styles';

const Layout: FC<{
  children: ReactNode;
  pageName: string;
  config: IConfig;
  language: string;
  categories?: string[];
}> = ({ children, pageName, config, categories = [], language }) => (
  <ThemeProvider theme={globalVariables}>
    <GlobalStyle config={config.general} />
    <Header isHome={pageName === 'home'} config={config} language={language} />
    <main className={`page-${pageName}`}>{children}</main>
    <Footer config={config} categories={categories || []} language={language} />
    <CookiesConsent isPolicyView={pageName === 'cookiePolicy'} config={config} language={language} />
  </ThemeProvider>
);

export default Layout;
